import { c as _c } from "react/compiler-runtime";
import { IcoCheckCircle16, IcoInfo16, IcoWarning16 } from '@onefootprint/icons';
import type { NewUserInsightUnit, UserInsight } from '@onefootprint/request-types/dashboard';
import { Tooltip } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
const Item = t0 => {
  const $ = _c(17);
  const {
    name,
    value,
    description,
    insightUnit
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = capitalize(name);
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const capitalizedName = t1;
  let t2;
  if ($[2] !== description) {
    t2 = description && <Tooltip content={description}><IcoInfo16 /></Tooltip>;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== capitalizedName || $[5] !== t2) {
    t3 = <div className="flex items-center text-body-2 max-w-[50%] truncate gap-2">{capitalizedName}{t2}</div>;
    $[4] = capitalizedName;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative flex-1 border-b border-dashed border-tertiary" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== insightUnit || $[9] !== value) {
    t5 = formatValue(value, insightUnit);
    $[8] = insightUnit;
    $[9] = value;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5 || $[12] !== value) {
    t6 = <p className="text-body-2 max-w-[50%] truncate" title={value}>{t5}</p>;
    $[11] = t5;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="flex relative gap-2 items-baseline py-2 w-full">{t3}{t4}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
const formatDurationMs = (ms: number): string => {
  const seconds = Math.floor(ms / 1000) % 60;
  const minutes = Math.floor(ms / 60000) % 60;
  const hours = Math.floor(ms / 3600000) % 24;
  const days = Math.floor(ms / 86400000);
  const parts = [];
  if (days > 0) {
    parts.push(`${days}${'d'}`);
  }
  if (hours > 0) {
    parts.push(`${hours}${'h'}`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}${'m'}`);
  }
  if (seconds > 0 || hours === 0 && minutes === 0) {
    parts.push(`${seconds}${'s'}`);
  }
  return parts.join(' ');
};
const formatValue = (value: string, unit: NewUserInsightUnit) => {
  if (unit.kind === 'duration_ms') {
    const ms = Number.parseInt(value, 10);
    return formatDurationMs(ms);
  }
  if (unit.kind === 'boolean') {
    const {
      severity
    } = unit.data;
    const isTrue = value === 'true';
    const isGood = severity === 'good';
    const baseValue = isTrue ? 'Yes' : 'No';
    const status = isGood && isTrue || !isGood && !isTrue ? <IcoCheckCircle16 color="success" /> : <IcoWarning16 color="error" />;
    return <span className="flex gap-1 items-center">
        {baseValue} {status}
      </span>;
  }
  return value;
};
export default Item;